import React from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSwitcher.css';

function LanguageSwitcher({ iconOnly = false }) {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'zh-TW' : 'en';
    i18n.changeLanguage(newLang);
  };

  const label = i18n.language === 'en' ? 'EN' : '繁';

  return (
    <div className="language-switcher">
      <button 
        className={`lang-toggle-btn ${iconOnly ? 'icon-only' : ''}`}
        onClick={toggleLanguage}
        aria-label={`Switch to ${i18n.language === 'en' ? 'Traditional Chinese' : 'English'}`}
        title={`Switch to ${i18n.language === 'en' ? 'Traditional Chinese' : 'English'}`}
      >
        {iconOnly ? (
          <span style={{ fontSize: 12, fontWeight: 700 }}>{label}</span>
        ) : (
          label
        )}
      </button>
    </div>
  );
}

export default LanguageSwitcher;
